// var basepath = 'http://localhost:9001/api/';

/* Routes*/
import { MODE } from '../constants/constants';

const basepath = (MODE === "debug") ? 'http://localhost:9001/api/' : 'https://api.laguiavalentinaquintero.com/api/';
export default {
    buscar: basepath + "poi/buscar", // + ?q={busqueda}

    info: basepath + 'info',
    //Puntos de Interes (POI)
    poiAll: basepath + 'poi',
    poiById: basepath + 'poi/' /*+ {Id}*/,

    //Tipo de Puntos de Interes
    tipoPoiAll: basepath + 'tipopoi',
    tipoPoiById: basepath + 'tipopoi/' /*+ {Id}*/,

    //Posadas
    posadaAll: basepath + 'posada',
    posadaById: basepath + 'posada/' /*+ {Id}*/,

    //Regiones
    regionAll: basepath + 'region',
    regionById: basepath + 'region/' /*+ {Id}*/,

    //Rutas
    rutaAll: basepath + 'ruta',
    rutaById: basepath + 'ruta/' /*+ {Id}*/,

    //Sectores
    sectorAll: basepath + 'sector',
    sectorById: basepath + 'sector/' /*+ {Id} + / + posadas?*/,
    sectorPoiById: basepath + 'sector/' /*+ {Id} + / + pois?*/,

    //Servicios
    servicioAll: basepath + 'servicio',
    servicioById: basepath + 'servicio/' /*+ {Id} + / + pois?*/,

    //Tipo de Servicios
    tipoCaminoAll: basepath + 'tipocamino',
    tipoCaminoById: basepath + 'tipocamino/' /*+ {Id} + / + servicios?*/,

    //Tipos de Camino
    tipoServicioAll: basepath + 'tipocamino',
    tipoServicioById: basepath + 'tipocamino/' /*+ {Id} */,

    //Estados
    estadoBy: basepath + 'estado' /*+ {Estado} + / + [rutas | sectores | regiones] */,
    estadosSectores: basepath + 'estado',

    contacto: basepath + 'contacto',
};



// WEBPACK FOOTER //
// ./src/constants/routes.js